<template>
  <!-- 全域浮動式按鈕-->
  <div
    class="floatBtn"
    draggable="true"
    @dragstart="onDragStart"
    @dragend="onDragEnd"
    :style="{ left: coordinate.x + 'px', top: coordinate.y + 'px' }"
    v-click-outside="handleClick"
    ref="buttonRef"
  >
    <el-tooltip class="box-item" effect="dark" content="Help" placement="top-end">
      <el-icon type="primary" :size="40" color="#F75000">
        <QuestionFilled />
      </el-icon>
    </el-tooltip>
  </div>

  <el-popover
    ref="popoverRef"
    :virtual-ref="buttonRef"
    trigger="click"
    :title="`${this.i18n.$t('DriverTourHelp')['SmartNavigationAssistant']}`"
    virtual-triggering
    hidden="300"
    width="330"
  >
    <el-row>
      <div class="flex gap-4 mb-4 items-center">
        <el-input
          size="large"
          v-model="searchName"
          style="width: 240px"
          :placeholder="`${this.i18n.$t('DriverTourHelp')['PleaseEnterFunctionName']}`"
        />
        <el-button @click="searchRouterList()" size="large">
          <el-icon><Search /></el-icon>
        </el-button>
      </div>
    </el-row>

    <el-row>
      <el-scrollbar height="200px">
        <el-card
          class="custom-card"
          v-for="item in filterRouteList"
          :key="item.id"
          style="max-width: 295px"
          shadow="always"
        >
          <el-link type="primary" @click="clickOpenHelpDriverTour(item.id)">
            {{ item.functionName }}
          </el-link>
          <p>{{ item.description }}</p>
        </el-card>
      </el-scrollbar>
    </el-row>

    <el-row>
      <!-- 選擇語系 -->
      <el-form-item :label="i18n.$t('DriverTourHelp').ChoiceLanguage">
        <el-select v-model="getLang" @change="setLang">
          <el-option value="zhtw" :label="i18n.$t('Lang_op_tw')"></el-option>
          <el-option value="cn" :label="i18n.$t('Lang_op_cn')"></el-option>
          <el-option value="en" :label="i18n.$t('Lang_op_en')"></el-option>
        </el-select>
      </el-form-item>
    </el-row>
  </el-popover>
</template>

<script>
import { useI18n } from '@/js/i18n';
import { store } from '@/store';
import {
  defineComponent,
  nextTick,
  ref,
  reactive,
  onMounted,
  watch,
  computed,
  onUnmounted,
} from 'vue';
import { ClickOutside as vClickOutside } from 'element-plus';

export default defineComponent({
  directives: {
    clickOutside: vClickOutside,
  },
  props: {
    /** driver.js旅程功能路由資料列表來源 */
    driverTourRouteSourceList: {
      type: Object,
      required: true,
    },

    /** 按下事件之Function-開啟導覽旅程 */
    clickOpenHelpDriverTour: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const i18n = useI18n();

    /** 按鈕ref */
    const buttonRef = ref(null);

    /** 提示框ref */
    const popoverRef = ref(null);

    /** 按下事件 */
    const handleClick = () => {
      nextTick(() => {
        popoverRef.value?.popperRef?.delayHide?.();
      });
    };

    /** 瀏覽器視窗高度 */
    const currentHeight = ref(window.innerHeight);

    /** 瀏覽器視窗寬度 */
    const currentWidth = ref(window.innerWidth);

    /** 座標 */
    const coordinate = reactive({
      x: 20,
      y: currentHeight.value - 120,
    });

    /** 起始X位置 */
    const startX = ref(0);

    /** 起始Y位置 */
    const startY = ref(0);

    /** 開始拖曳 */
    function onDragStart(e) {
      console.log('onDragStart e', e);

      startX.value = e.clientX;
      startY.value = e.clientY;
    }

    /** 拖曳結束 */
    function onDragEnd(e) {
      let correctX = e.clientX;
      if (e.clientX < 20) {
        correctX = 20;
      } else if (e.clientX > currentWidth.value - 20) {
        correctX = currentWidth.value - 20;
      }

      let correctY = e.clientY;
      if (e.clientY < 100) {
        correctY = 100;
      } else if (e.clientY > currentHeight.value - 20) {
        correctY = currentHeight.value - 20;
      }

      const deltaX = correctX - startX.value;
      const deltaY = correctY - startY.value;

      console.log('deltaX ', deltaX);
      console.log('deltaY', deltaY);

      coordinate.x += deltaX;
      coordinate.y += deltaY;
    }

    /** 視窗大小變更 */
    function updateWindowSize() {
      coordinate.y = window.innerHeight - 120;
    }

    /** 功能路由列表 */
    const routeList = ref([]);

    /** 過濾的功能路由列表 */
    const filterRouteList = reactive([]);

    /** 搜尋路由名稱 */
    const searchName = ref('');

    /** 初始功能路由列表 */
    function initRouterList() {
      filterRouteList.splice(0, filterRouteList.length);

      routeList.value.forEach((element) => {
        filterRouteList.push(element);
      });
    }

    /** 依照名稱關鍵字搜尋功能路由列表 */
    function searchRouterList() {
      const filterDataByName = routeList.value.filter((element) => {
        return element.functionName.includes(searchName.value);
      });

      const filterDataByDescription = routeList.value.filter((element) => {
        return element?.description?.includes?.(searchName.value);
      });

      // 聯集陣列資料
      const filterData = [...new Set([...filterDataByName, ...filterDataByDescription])];

      console.log('searchRouterList filterData', filterData);

      filterRouteList.splice(0, filterRouteList.length);
      filterData.forEach((element) => {
        filterRouteList.push(element);
      });
    }

    /** 預設語系或取得store語系 */
    const getLang = computed(() => {
      let lang = 'zhtw';
      if (store.state.lang) {
        lang = store.state.lang;
      }
      return lang;
    });

    /** 選取設定語系 */
    const setLang = (value) => {
      store.commit('setLang', value);
      sessionStorage.setItem('userLang', value);
      i18n.locale.value = value;
    };

    watch(
      () => props.driverTourRouteSourceList,
      (newVal) => {
        routeList.value = [...newVal];
        console.log('watch routeList', routeList.value);
        initRouterList();
      },
      { immediate: true, deep: true },
    );

    onMounted(() => {
      initRouterList();
      window.addEventListener('resize', updateWindowSize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateWindowSize);
    });

    return {
      i18n,

      /** 按鈕ref */
      buttonRef,

      /** 提示框ref */
      popoverRef,

      /** 座標 */
      coordinate,

      /** 按下事件 */
      handleClick,

      /** 開始拖曳 */
      onDragStart,

      /** 拖曳結束 */
      onDragEnd,

      /** 功能路由列表 */
      routeList,

      /** 過濾的功能路由列表 */
      filterRouteList,

      /** 搜尋路由名稱 */
      searchName,

      /** 初始功能路由列表 */
      initRouterList,

      /** 分派給功能路由列表 */
      // dispatchRouteList,

      /** 依照名稱關鍵字搜尋功能路由列表 */
      searchRouterList,

      vClickOutside,

      /** 預設語系或取得store語系 */
      getLang,

      /** 選取設定語系 */
      setLang,
    };
  },
});
</script>

<style scoped>
.floatBtn {
  position: absolute;
  top: 20px;
  right: 45px;
  width: 100px;
  height: 100px;
  cursor: grab;
  z-index: 999;
}

.custom-card {
  border: 1px solid var(--el-border-color);
  border-radius: 10px;
  margin-top: 5px;
}

.custom-card ::v-deep(.el-card__body) {
  padding: 10px;
  width: 295px;
}
</style>
